import FoldMenuIcon from './component'

export default FoldMenuIcon
